<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="thank-you-pop">
              <div class="row" v-if="image">
                <img :src="image" />
              </div>
              <h2 :class="bodyClass">{{ message }}</h2>
              <!-- Checkbox for TMS sync -->
              <div class="form-check mt-3 text-center">
                <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="syncToTms"
                    :id="'syncTmsCheckbox' + _uid"
                />
                <label class="form-check-label" :for="'syncTmsCheckbox' + _uid">
                  Check if you need to init syncing to TMS directly without exporting json file
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="closeModal">
              Cancel
            </button>
            <button type="button" class="btn btn-gradient-success" @click="confirm" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              {{ confirmBtnText || 'Confirm' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: { type: String, default: 'Export JSON' },
    message: { type: String, default: 'Are you sure to export this?' },
    image: String,
    bodyClass: String,
    confirmBtnText: String,
  },
  data() {
    return {
      syncToTms: false,
      loading: false,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.syncToTms = false; // reset checkbox when opened
        this.loading = false;
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('hide');
    },
    async confirm() {
      try {
        // Emit event with the checkbox value; parent handles actual API call
        await this.$emit('confirmExport', this.syncToTms);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
/* reuse your existing modal styles if needed */
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}
.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}
.form-check {
  text-align: left;
  margin-top: 20px;
}
</style>